import Aztec from './Aztec'

export default Aztec
